import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { RoleService } from './role.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(private roleService: RoleService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    _: RouterStateSnapshot): boolean | Promise<boolean> {
      return true;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    snapshot: RouterStateSnapshot): boolean | Promise<boolean> {

    return (async (): Promise<boolean> => {
      let hasPermission = false;
      await this.roleService.getPermissionsByCurrentUser()
      .forEach(resp => {
        resp.result.forEach(permission => {
          if (permission == next.routeConfig.path
              || '/' + permission == snapshot.url) hasPermission = true;
        });
      });

      return hasPermission;
    })();
  }
  canLoad(
    route: Route,
    _: UrlSegment[]): boolean | Promise<boolean> {
      return true;
  }
}

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  constructor(private authService: AuthService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    _: RouterStateSnapshot): boolean | Promise<boolean> {
      return this.authService.getLoggedUser().userId == 0;
  }
}
